import type { HourSlot, Slot } from '@utils/interfaces';
import dayjs from 'dayjs';

export const createHourSlotGroups = (slots?: Slot[]): Slot[] => {
  const tempSlots: Slot[] = [
    {
      list: [],
      timeSlotOrder: 1,
    },
    {
      list: [],
      timeSlotOrder: 2,
    },
    {
      list: [],
      timeSlotOrder: 3,
    },
  ];

  for (const slot of slots || []) {
    tempSlots[slot.timeSlotOrder - 1].list = slot.list.map(hourSlot => ({
      ...hourSlot,
      internalSlots: (hourSlot.internalSlots || []).map(internalSlot => ({
        ...internalSlot,
      })),
    }));
  }

  return tempSlots;
};

export const sortHourSlots = (hourSlots: HourSlot[]): HourSlot[] => {
  return hourSlots.sort((a, b) => {
    const byDay = dayjs(a?.startTime).valueOf() - dayjs(b?.startTime).valueOf();
    if (byDay !== 0) return byDay;
    const byDoctorId = a?.doctorId?.localeCompare(b?.doctorId ?? '') ?? 0;
    if (byDoctorId !== 0) return byDoctorId;
    return a?.startTime?.localeCompare(b?.startTime ?? '') ?? 0;
  });
};
